import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const defaultRedirect = '/signin';

const useAuthGuard = (redirectTo = defaultRedirect) => {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const checkAuthentication = async () => {
      try {
        const result = await window.catalyst?.auth?.isUserAuthenticated?.();
        const unauthenticated = !result || result.status === 401;

        if (!cancelled && unauthenticated) {
          navigate(redirectTo);
          return;
        }

        if (!cancelled) {
          setAuthenticated(true);
        }
      } catch (err) {
        if (!cancelled) {
          navigate(redirectTo);
          return;
        }
      } finally {
        if (!cancelled) {
          setChecking(false);
        }
      }
    };

    checkAuthentication();

    return () => {
      cancelled = true;
    };
  }, [navigate, redirectTo]);

  return { checking, authenticated };
};

export default useAuthGuard;
